/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./biography.vue?vue&type=template&id=2891e8d9&scoped=true"
import script from "./biography.vue?vue&type=script&lang=js"
export * from "./biography.vue?vue&type=script&lang=js"
import style0 from "./biography.vue?vue&type=style&index=0&id=2891e8d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891e8d9",
  null
  
)

export default component.exports